import { ChangeEvent, FormEvent } from "react";
import { CreateEmployerJob } from "types/employer.interface";

interface Props {
  onNext: () => void;
  onBack: () => void;
  input: CreateEmployerJob;
  userId?: string;
  onChange: (
    e:
      | ChangeEvent<HTMLInputElement>
      | ChangeEvent<HTMLSelectElement>
      | ChangeEvent<HTMLTextAreaElement>
      | {
          target: {
            name: string;
            value: string | number;
          };
        }
  ) => void;
  onChangeByNameValue: (name: keyof CreateEmployerJob, value: any) => void;
  isLoading?: boolean;
}

export default function JobDetails({
  onNext,
  input,
  onChange,
  onChangeByNameValue,
  onBack,
  userId,
  isLoading,
}: Props) {
  const submitHandler = async (e: FormEvent) => {
    e.preventDefault();

    onNext();
  };

  return (
    <div className="w-full ">
      <form onSubmit={submitHandler} className=" flex flex-col gap-8 ">
        <div className="flex flex-col gap-1">
          <h2 className=" font-body font-medium text-lg lg:text-xl leading-5 text-body">
            Job Details
          </h2>
        </div>

        <div className="flex flex-col gap-2">
          <label htmlFor="description">Full Job Description</label>
          <textarea
            placeholder="describe the job in your own words"
            id="description"
            name="description"
            value={input.description}
            onChange={onChange}
            required
            className="border bg-input border-gray-300 rounded-sm px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          ></textarea>
        </div>

        <div className="flex flex-col gap-2">
          <label htmlFor="expectedStartDate">Preferred Start Date</label>
          <input
            placeholder=""
            id="expectedStartDate"
            name="expectedStartDate"
            value={input.expectedStartDate!}
            onChange={onChange}
            required
            type="date"
            className="border bg-input border-gray-300 rounded-sm px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="flex flex-col gap-2">
          <label htmlFor="endDate">Preferred End Date</label>
          <input
            placeholder=""
            id="endDate"
            name="endDate"
            value={input.endDate!}
            onChange={onChange}
            type="date"
            className="border bg-input border-gray-300 rounded-sm px-3 py-2 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="flex items-center gap-4 mt-8">
          <button onClick={onBack} className=" px-10">
            Back
          </button>
          <button
            disabled={isLoading}
            className="px-4 py-2 text-sm rounded-lg bg-indigo-600 text-white font-medium hover:bg-indigo-700 disabled:opacity-60 transition-colors"
          >
            {isLoading ? "Loading..." : "Save"}
          </button>
        </div>
      </form>
    </div>
  );
}
